import { NameSpace } from '../../enums/enum';
import {State} from '../../types/state';

export const getMenuState = (state: State): boolean => state[NameSpace.MainData].openMenu;
export const getLoadingState = (state: State): boolean => state[NameSpace.MainData].loading;